import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from 'components/shared/modal/FormModal';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import {
  getShowOpenItemFormModal,
  getCritical,
} from 'components/admin/projects/details/project-open-items/store/selectors';
import {
  closeOpenItemFormModal,
  createProjectOpenItem,
} from 'components/admin/projects/details/project-open-items/store/actions';
import ProjectOpenItemForm from 'components/admin/projects/details/project-open-items/ProjectOpenItemForm';
import './ProjectOpenItemFormModal.css';

class ProjectOpenItemFormModal extends Component {
  handleOpenItemFormModalClose = () => {
    this.props.dispatch(closeOpenItemFormModal());
  };

  handleSave = (values) => {
    const { currentProject, dispatch } = this.props;
    dispatch(createProjectOpenItem(currentProject.id, values));
  };

  modalTitle = () => {
    return this.props.critical ? 'New Critical Open Item' : 'New Open Item';
  };

  render() {
    const { currentProject, showOpenItemFormModal } = this.props;
    return (
      showOpenItemFormModal && (
        <FormModal
          className="project-open-item-form-modal"
          show={showOpenItemFormModal}
          onClose={this.handleOpenItemFormModalClose}
          subTitle={<RouteTitle titles={['Projects', currentProject.name]} />}
          title={this.modalTitle()}
        >
          <ProjectOpenItemForm
            onSave={this.handleSave}
            onCancel={this.handleOpenItemFormModalClose}
          />
        </FormModal>
      )
    );
  }
}

export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
    showOpenItemFormModal: getShowOpenItemFormModal(state),
    critical: getCritical(state),
  };
})(ProjectOpenItemFormModal);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-open-items/ProjectOpenItemFormModal.js